import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  key: 0,
  id: "main-content-port"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  class: "w100 llgreyBg",
  style: {"height":"40px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "w100" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "企業URL"),
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_11 = {
  class: "fl w60",
  style: {"margin-top":"20px"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600 mt10" }, [
  /*#__PURE__*/_createTextVNode(" 公開ページで表示される統一したURLを設定します。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs12 fw400" }, "半角英数字（3文字以上）が使用可能です。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs12 fw600 text-warning" }, "※　変更すると、公開しているすべての公開ページのURLが変更になります。")
], -1)
const _hoisted_13 = {
  class: "fl",
  style: {"width":"280px"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = { class: "w100" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10 mt10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "アドレス帳登録"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt30" }, " アドレス帳への自動登録の有無を設定できます。自動登録にしておくと、日程が確定や提案されたタイミングでお相手の入力したフォームの内容をもとに自動で登録されます。次回日程調整する場合など、アドレス帳から事前にフォームに埋めてお相手に送ることができます。 "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_19 = {
  class: "fl w60",
  style: {"margin-top":"20px"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = { class: "w100" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fl mr5" }, "タイムゾーンの変更")
  ]),
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }, " 調整ページを開いた際に、調整相手がタイムゾーンを自由に変更できるようにします。 "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_24 = {
  key: 0,
  class: "fl w60 mt20",
  style: {}
}
const _hoisted_25 = {
  class: "fl",
  style: {"width":"200px"}
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: `_change_timezone`,
  class: "fs12 fw600"
}, " タイムゾーン変更を有効", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = { class: "w100" }
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"fl w30 pad10\"><h5 class=\"fw600\"><span class=\"fl mr5\">調整カレンダーで手動モードの際に、絞り込みの設定</span></h5><p style=\"margin-top:50px;\"> 調整カレンダーで手動モードの際に、期間や時間の絞り込みの設定を無効にし、選択した日程を期間気にせず表示することができます。<br><span class=\"fs11\"> 無効にする項目：<br><ul class=\"ml10 fs11\"><li>開始日程・終了日程（固定期間・相対期間）</li><li>土日祝日考慮</li><li>移動時間考慮（前後のバッファ時間）</li></ul></span><span class=\"fs12 fw600 text-warning\"> ※ 再調整時には無効にならず、設定した期間や時間を考慮した日程が表示されます。 </span></p><br></div>", 1)
const _hoisted_31 = {
  key: 0,
  class: "fl w60 mt20",
  style: {}
}
const _hoisted_32 = {
  class: "fl",
  style: {"width":"400px"}
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  for: `_ignore_filters_if_manual_mode`,
  class: "fs12 fw600"
}, " 絞り込みを無効", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = { class: "w100" }
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<div class=\"fl w30 pad10\"><h5 class=\"fw600\"><span class=\"fl mr5\">Googleカレンダーの「予定なし」イベントを表示</span></h5><p style=\"margin-top:50px;\"> Googleカレンダーで「予定あり」「予定なし」のどちらでも、イベントとして認識します。<br> チェックをはずすと、「予定あり」のみをイベントとして認識します。<br><span class=\"fs12 fw600 text-warning\"> ※変更を即時反映させたい場合は、対象の公開ページを更新してください。 </span></p><br></div>", 1)
const _hoisted_38 = {
  key: 0,
  class: "fl w60 mt20",
  style: {}
}
const _hoisted_39 = {
  class: "fl",
  style: {"width":"400px"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  for: `_can_use_event_if_google_transparency_is_transparent`,
  class: "fs12 fw600"
}, " 「予定あり」「予定なし」でもイベントとして認識する", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = { class: "w100" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fl mr5" }, "外部カレンダーのオーナーをイベントの出席者にも追加")
  ]),
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }, [
    /*#__PURE__*/_createTextVNode(" 外部カレンダーのオーナーをイベントの出席者に追加します。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 出席者に追加しない場合でも、外部カレンダーの予定に入っているため、ブロックされる予定として認識されます。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 外部のツール連携で必要な場合にご利用ください。 ")
  ]),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_45 = {
  key: 0,
  class: "fl w60 mt20",
  style: {}
}
const _hoisted_46 = {
  class: "fl",
  style: {"width":"400px"}
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  for: `_add_attendee_if_calendar_owner`,
  class: "fs12 fw600"
}, " 外部カレンダーのオーナーも出席者にも追加する", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_50 = {
  key: 0,
  class: "w100"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fl mr5" }, "別グループを作成")
  ]),
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }, [
    /*#__PURE__*/_createTextVNode(" 同一企業が管理する別グループを作成できます。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("オプションとなっておりますので、担当者にご確認の上、申請ください。 ")
  ]),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_52 = {
  key: 0,
  class: "fl w60 mt20",
  style: {}
}
const _hoisted_53 = {
  class: "fl",
  style: {"width":"200px"}
}
const _hoisted_54 = {
  class: "fl",
  style: {"width":"280px"}
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "w100" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fl mr5" }, "icsファイルをメール内に設置")
  ]),
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }, [
    /*#__PURE__*/_createTextVNode(" 日程確定時にicsファイルを確定通知を添付することができます。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" icsファイルから1クリックでカレンダーにイベントを登録できるようになります。 ")
  ]),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_63 = {
  key: 0,
  class: "fl w60 mt20",
  style: {}
}
const _hoisted_64 = {
  class: "fl",
  style: {"width":"200px"}
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", {
  for: `_attach_ics_file`,
  class: "fs12 fw600"
}, " icsファイルを設置", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_68 = { class: "w100" }
const _hoisted_69 = { class: "fl w30 pad10" }
const _hoisted_70 = { class: "fw600" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", { class: "fl mr5" }, "メールドメイン設定", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_74 = {
  class: "fl w60",
  style: {"margin-top":"20px"}
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600 mt10" }, [
  /*#__PURE__*/_createTextVNode("メール独自ドメインを設定します"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_76 = { key: 0 }
const _hoisted_77 = {
  key: 1,
  class: "mt20"
}
const _hoisted_78 = {
  class: "fl",
  style: {"width":"280px"}
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_80 = { key: 2 }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_AccountHeader = _resolveComponent("AccountHeader")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_IconLock = _resolveComponent("IconLock")!
  const _component_EmailDomainContent = _resolveComponent("EmailDomainContent")!
  const _component_AlertModal = _resolveComponent("AlertModal")!
  const _component_OptionModal = _resolveComponent("OptionModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `account` }),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createVNode(_component_AccountHeader, {
                selectedTab: _ctx.selectedTab,
                ref: "header"
              }, null, 8, ["selectedTab"]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(`fs12 mt2 fl pointer pad10 ml20 ${_ctx.selectedCategory == `general` ? `fw600 selected` : ``}`),
                  style: {"width":"120px"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectCategory(`general`)))
                }, " 全般 ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(`fs12 mt2 fl pointer pad10 ${_ctx.selectedCategory == `mail` ? `fw600 selected` : ``}`),
                  style: {"width":"140px"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCategory(`mail`)))
                }, " メール ", 2),
                _hoisted_6
              ]),
              _hoisted_7,
              (_ctx.selectedCategory == `general`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_MdTextfieldTag, {
                            fieldStyle: "min-width:280px;max-width:100%;",
                            style: {"height":"56px","min-width":"280px","max-width":"100%"},
                            class: "fl fs16",
                            type: `AstagName`,
                            placeholder: `waaq`,
                            value: _ctx.namespace,
                            onInputValue: _ctx.inputNamespace,
                            onBlur: _ctx.checkName,
                            errMessage: _ctx.validName ? null : `入力してください。`,
                            required: ""
                          }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"])
                        ]),
                        _createElementVNode("button", {
                          type: "submit",
                          class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 ml20",
                          style: {"height":"50px"},
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createNamespace && _ctx.createNamespace(...args)))
                        }, " 決定 "),
                        _hoisted_14,
                        (_ctx.Util.isPresent(_ctx.ngReasons))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ngReasons, (ngMessage) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: ngMessage,
                                  class: "alertRed fw600 fs11"
                                }, _toDisplayString(ngMessage), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_SelectTag, {
                          name: "addressbook_auto",
                          id: "addressbook_auto",
                          class: "fl fs14 roundForm",
                          style: {"min-width":"130px","height":"50px","margin-top":"10px"},
                          options: _ctx.SelectUtil.addressbookAutoRegiTypes.map(m => m.name),
                          defaultOption: 
                                        _ctx.autoRegiType
                                            ? _ctx.SelectUtil.addressbookAutoRegiTypes.find(d => d.type == _ctx.autoRegiType).name
                                            : `自動登録する`
                                    ,
                          onSelectValue: _ctx.selectAddressbookAutoRegistType
                        }, null, 8, ["options", "defaultOption", "onSelectValue"])
                      ]),
                      _hoisted_20
                    ]),
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      (_ctx.ug)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(_component_CheckboxTag, {
                                name: `change_timezone`,
                                value: `change_timezone`,
                                checked: _ctx.ug.user_group_setting.can_change_timezone,
                                prefix: ``,
                                onClickCheckbox: _ctx.clickChangeTimezone
                              }, null, 8, ["checked", "onClickCheckbox"]),
                              _hoisted_26
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_27
                    ]),
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      (_ctx.ug)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_CheckboxTag, {
                                name: `ignore_filters_if_manual_mode`,
                                value: `ignore_filters_if_manual_mode`,
                                checked: _ctx.ug.user_group_setting.can_ignore_filters_if_manual_mode,
                                prefix: ``,
                                onClickCheckbox: _ctx.clickChangeIgnoreFilters
                              }, null, 8, ["checked", "onClickCheckbox"]),
                              _hoisted_33
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_34
                    ]),
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      (_ctx.ug)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(_component_CheckboxTag, {
                                name: `can_use_event_if_google_transparency_is_transparent`,
                                value: `can_use_event_if_google_transparency_is_transparent`,
                                checked: _ctx.ug.user_group_setting.can_use_event_if_google_transparency_is_transparent,
                                prefix: ``,
                                onClickCheckbox: _ctx.clickChangeUseEventIfGoogleTransparencyIsTransparent
                              }, null, 8, ["checked", "onClickCheckbox"]),
                              _hoisted_40
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_41
                    ]),
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      (_ctx.ug)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _createVNode(_component_CheckboxTag, {
                                name: `add_attendee_if_calendar_owner`,
                                value: `add_attendee_if_calendar_owner`,
                                checked: _ctx.ug.user_group_setting.add_attendee_if_calendar_owner,
                                prefix: ``,
                                onClickCheckbox: _ctx.clickChangeAddAttendeeIfCalendarOwner
                              }, null, 8, ["checked", "onClickCheckbox"]),
                              _hoisted_47
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_48
                    ]),
                    _hoisted_49,
                    false
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _hoisted_51,
                          (_ctx.ug)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _createVNode(_component_MdTextfieldTag, {
                                      fieldStyle: "min-width:280px;max-width:100%;",
                                      style: {"height":"56px","min-width":"280px","max-width":"100%"},
                                      class: "fs16",
                                      type: `NewUgName`,
                                      placeholder: `waaq`,
                                      value: _ctx.newUgInfo.name,
                                      onInputValue: _ctx.inputNewUgName,
                                      onBlur: _ctx.checkNewUgName,
                                      errMessage: _ctx.validUgName ? null : `入力してください。`,
                                      required: ""
                                    }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"]),
                                    _hoisted_55,
                                    _createVNode(_component_MdTextfieldTag, {
                                      fieldStyle: "min-width:280px;max-width:100%;",
                                      style: {"height":"56px","min-width":"280px","max-width":"100%"},
                                      class: "fs16",
                                      type: `NewUgShortName`,
                                      placeholder: `waaq`,
                                      value: _ctx.newUgInfo.short_name,
                                      onInputValue: _ctx.inputNewUgShortName,
                                      onBlur: _ctx.checkNewUgShortName,
                                      errMessage: _ctx.validUgShortName ? null : `入力してください。`,
                                      required: ""
                                    }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"]),
                                    _hoisted_56,
                                    _createVNode(_component_MdTextfieldTag, {
                                      fieldStyle: "min-width:280px;max-width:100%;",
                                      style: {"height":"56px","min-width":"280px","max-width":"100%"},
                                      class: "fs16",
                                      type: `NewUgNamespace`,
                                      placeholder: `waaq`,
                                      value: _ctx.newUgInfo.namespace,
                                      onInputValue: _ctx.inputNewUgNamespace,
                                      onBlur: _ctx.checkNewUgNamespace,
                                      errMessage: _ctx.validUgNamespace ? null : `入力してください。`,
                                      required: ""
                                    }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"]),
                                    _hoisted_57
                                  ]),
                                  _createElementVNode("button", {
                                    type: "submit",
                                    class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 ml20",
                                    style: {"height":"50px"},
                                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitNewUg && _ctx.submitNewUg(...args)))
                                  }, " 申請 ")
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_58
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_59
                  ]))
                : (_ctx.selectedCategory == `mail`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _hoisted_62,
                        (_ctx.ug)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                              _createElementVNode("div", _hoisted_64, [
                                _createVNode(_component_CheckboxTag, {
                                  name: `attach_ics_file`,
                                  value: `attach_ics_file`,
                                  checked: _ctx.ug.user_group_setting.can_attach_ics_file,
                                  prefix: ``,
                                  onClickCheckbox: _ctx.clickAttachmentIcsFile
                                }, null, 8, ["checked", "onClickCheckbox"]),
                                _hoisted_65
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_66
                      ]),
                      _hoisted_67,
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("h5", _hoisted_70, [
                            _hoisted_71,
                            (!_ctx.canUseDomain)
                              ? (_openBlock(), _createBlock(_component_IconLock, {
                                  key: 0,
                                  style: {"margin-top":"-2px"},
                                  class: "ml10 fl",
                                  width: 16
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_72,
                          _hoisted_73
                        ]),
                        _createElementVNode("div", _hoisted_74, [
                          _hoisted_75,
                          (!_ctx.emailDomains)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_76))
                            : (_ctx.emailDomains.length == 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                  _createElementVNode("div", _hoisted_78, [
                                    _createVNode(_component_MdTextfieldTag, {
                                      fieldStyle: "min-width:280px;max-width:100%;",
                                      style: {"height":"56px","min-width":"280px","max-width":"100%"},
                                      class: "fl fs16",
                                      type: `AstagName`,
                                      placeholder: `waaq`,
                                      value: _ctx.maildomain,
                                      onInputValue: _ctx.inputMailDomain,
                                      onBlur: _ctx.checkMailDomain,
                                      onClickTextfield: _ctx.clickMailDomainField,
                                      errMessage: _ctx.validName ? null : `入力してください。`,
                                      required: ""
                                    }, null, 8, ["value", "onInputValue", "onBlur", "onClickTextfield", "errMessage"])
                                  ]),
                                  (_ctx.canUseDomain)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "submit",
                                        class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 ml20",
                                        style: {"height":"50px"},
                                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createMailDomain && _ctx.createMailDomain(...args)))
                                      }, " 送信 "))
                                    : _createCommentVNode("", true),
                                  _hoisted_79
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                  (_ctx.canUseDomain)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailDomains, (domain, domainindex) => {
                                          return (_openBlock(), _createBlock(_component_EmailDomainContent, {
                                            key: `${domainindex}${domain.submit_status}`,
                                            domain: domain,
                                            onUpdateDom: _ctx.updateDom,
                                            onRemoveDomain: _ctx.removeDomain
                                          }, null, 8, ["domain", "onUpdateDom", "onRemoveDomain"]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  _hoisted_82
                                ]))
                        ]),
                        _hoisted_83
                      ]),
                      _hoisted_84
                    ]))
                  : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_85
    ]),
    _createVNode(_component_AlertModal, {
      ref: "AlertModal",
      title: _ctx.alertDic ? _ctx.alertDic.title : ``,
      text: _ctx.alertDic ? _ctx.alertDic.text : ``,
      okButtonName: _ctx.alertDic ? _ctx.alertDic.buttonName : ``,
      eventName: _ctx.alertDic && _ctx.alertDic.type == `deleteDomain` ? null : _ctx.optionEventName,
      onClickOK: _ctx.clickOK,
      onClickCancel: _ctx.clickCancel
    }, null, 8, ["title", "text", "okButtonName", "eventName", "onClickOK", "onClickCancel"]),
    _createVNode(_component_OptionModal, {
      eventName: _ctx.optionEventName,
      onClickOK: _ctx.clickOK,
      onClickCancel: _ctx.clickCancel
    }, null, 8, ["eventName", "onClickOK", "onClickCancel"])
  ]))
}